import { BigNumber } from "@ethersproject/bignumber";

export const roundBn = (amount: BigNumber, decimals: number): BigNumber => {
  const divisor = BigNumber.from(10).pow(decimals);

  return amount.div(divisor).mul(divisor);
};
